import {
  getSupabaseProjectRefFromJwt,
  getSupabaseProjectRefFromUrl,
  sanitizeEnvValue,
} from '@/lib/env';

export function getSupabaseConfig() {
  const url = sanitizeEnvValue(process.env.NEXT_PUBLIC_SUPABASE_URL).replace(/\/+$/, '');
  const anonKey = sanitizeEnvValue(process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);
  const serviceRoleKey = sanitizeEnvValue(process.env.SUPABASE_SERVICE_ROLE_KEY);

  return {
    url,
    anonKey,
    serviceRoleKey,
  };
}

export function assertSupabaseAdminConfigConsistency() {
  const { url, serviceRoleKey } = getSupabaseConfig();
  const urlProjectRef = getSupabaseProjectRefFromUrl(url);
  const serviceRoleProjectRef = getSupabaseProjectRefFromJwt(serviceRoleKey);

  if (urlProjectRef && serviceRoleProjectRef && urlProjectRef !== serviceRoleProjectRef) {
    throw new Error(
      `SUPABASE_SERVICE_ROLE_KEY pertence ao projeto "${serviceRoleProjectRef}", mas NEXT_PUBLIC_SUPABASE_URL aponta para "${urlProjectRef}".`
    );
  }
}
